import { useQuery } from '@tanstack/react-query';
import type { RutaCobrosQuery } from '@aid/shared';
import { getDashboard, getRutaCobros } from './dashboard-service';
import { dashboardKeys } from './keys';

export function useDashboard() {
  return useQuery({
    queryKey: dashboardKeys.data(),
    queryFn: getDashboard,
    staleTime: 60_000,
  });
}

export function useRutaCobros(params: RutaCobrosQuery) {
  return useQuery({
    queryKey: dashboardKeys.rutaCobros(params),
    queryFn: () => getRutaCobros(params),
    staleTime: 30_000,
  });
}
